import { Component } from '@angular/core';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { ModalService } from 'src/app/shared/services/modal.service';
import { TableColumn } from 'src/app/shared/components/table/table-column.interface';
import { TableSearchRequest } from 'src/app/shared/components/table/table.component';
import { UserService } from 'src/app/shared/services/user.service';
import { UserDetailsComponent } from '../../user-details/user-details.component';

@Component({
  selector: 'app-internal-users-list',
  templateUrl: './internal-users-list.component.html',
  styleUrls: ['./internal-users-list.component.scss']
})
export class InternalUsersListComponent {

  userData: any[] = [];
  resultsLength: number = 0;
  isLoadingResults: boolean = false;
  lastRequest?: TableSearchRequest;
  faPlus = faPlus;

  columns: TableColumn[] = [
    { key: 'firstName',    label: 'First Name',      sortable: true, filterable: true },
    { key: 'lastName',     label: 'Last Name',       sortable: true, filterable: true },
    { key: 'emailAddress', label: 'Email',           sortable: true, filterable: true },
    { key: 'roleName',         label: 'Role',            sortable: true, filterable: true  },
    { key: 'isTeamLeader', label: 'Is Team Leader?',     sortable: true, filterable: true, filterType: 'select',
      filterOptions: [
        { label: 'Yes',  value: '{{bool}}true' },
        { label: 'No', value: '{{bool}}false' }
      ]},
    { key: 'teamLeaderName',   label: 'Team Leader',     sortable: true, filterable: true },
    { key: 'isAMLOfficer', label: 'AML Officer?',     sortable: true, filterable: true, filterType: 'select',
      filterOptions: [
        { label: 'Yes',  value: '{{bool}}true' },
        { label: 'No', value: '{{bool}}false' }
      ] },
    { key: 'lastLogin',    label: 'Last Login',      sortable: true, filterable: true, filterType: 'daterange' },
    { key: 'lastActivity', label: 'Last Activity',   sortable: true },
    { key: 'accountDisabled', label: 'Status',       sortable: true, filterable: true, filterType: 'select',
      filterOptions: [
        { label: 'Enabled',  value: '{{bool}}false' },
        { label: 'Disabled', value: '{{bool}}true' }
      ]
    },
  ];

  constructor(
    private userService: UserService,
    public modalService: ModalService) {
  }

  onSearch(request: TableSearchRequest) {
    this.lastRequest = request;
    this.isLoadingResults = true;
    this.userService.internalUsers(request).subscribe({
      next: data => {
        this.userData = data.items;
        this.resultsLength = data.recordCount;
        this.isLoadingResults = false;
      },
      error: () => this.isLoadingResults = false
    });
  }

  editUser(user: any) {
    const modalRef = this.modalService.openWithOptions(UserDetailsComponent, { size: 'lg' });
    modalRef.componentInstance.userId = user.id;
    modalRef.componentInstance.internalUser = true;
    modalRef.result.then(
      (result) => { if (result) this.onSearch(this.lastRequest!); },
      () => {}
    );
  }

  addUser() {
    const modalRef = this.modalService.openWithOptions(UserDetailsComponent, { size: 'lg' });
    modalRef.componentInstance.internalUser = true;
    modalRef.result.then(
      (result) => { if (result) this.onSearch(this.lastRequest!); },
      () => {}
    );
  }

  isOnline(lastActivity: string): boolean {
    if (!lastActivity) return false;
    return new Date(lastActivity) > new Date(Date.now() - 5 * 60 * 1000);
  }
}